<template>
  <div class="store-stat">
    <div class="card">
      fz
    </div>

    <div class="card overflow-auto mb-3" id="dbDemanderBoutique">
      <div class="card-header blue-gradient text-light text-center">
        <h4>Demander un magasin en ligne</h4>
      </div>
      <div class="card-body">
        <button class="btn btn-block btn-primary" id="demanderBoutiqueBtn">
          demander un magasin en ligne
        </button>

        <p class="mt-3">
          Pour pouvoir se procurer d'un magasin en ligne pour vendre des
          <span class="badge badge-primary">MATÉRIELS MÉDICAUX</span>, il vous
          faut cliquer sur le botton dessus et puis contacter l'administrateur
          de la page sur le numéro de télephone 0541229487
        </p>
      </div>
    </div>

    <div class="card d-none" id="dbAjouterDesVendeurs">
      <div class="card-header blue-gradient text-light text-center">
        <h4>Ajouter des Vendeurs</h4>
      </div>
      <div class="card-body overflow-auto">
        <div class="text-center">
          <a
            href=""
            id="addUser"
            class="btn btn-primary btn-rounded"
            data-toggle="modal"
            data-target="#modalLoginAvatar"
            >ajouter un utilisateur</a
          >
        </div>

        <!--Modal: Login with Avatar Form-->
        <div
          class="modal fade"
          id="modalLoginAvatar"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog cascading-modal modal-avatar modal-sm"
            role="document"
          >
            <!--Content-->
            <div class="modal-content">
              <!--Header-->
              <div class="modal-header">
                <img
                  src="@/assets/image/user.png"
                  alt="avatar"
                  class="rounded-circle img-responsive"
                />
              </div>
              <!--Body-->
              <div class="modal-body text-center mb-1">
                <h5 class="mt-1 mb-2">admin dashboard</h5>
                <p id="adminDash"></p>
                <div class="md-form ml-0 mr-0">
                  <input
                    type="email"
                    id="emailAjout"
                    class="form-control form-control-sm ml-0"
                  />
                  <label for="emailAjout" class="ml-0"
                    >L'email de l'utilisateur</label
                  >
                </div>

                <div class="text-center mt-4">
                  <button class="btn btn-primary mt-1" id="ajouterviamail">
                    Ajouter<i class="fa fa-sign-in ml-1"></i>
                  </button>
                </div>
              </div>
            </div>
            <!--/.Content-->
          </div>
        </div>
        <!--Modal: Login with Avatar Form-->

        <table
          id="dt6"
          class="table table-striped table-bordered"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr>
              <th></th>
              <th class="th-sm">Le nom complet</th>
              <th class="th-sm">L'émail</th>
              <th class="th-sm">Statut de la demande</th>
            </tr>
          </thead>
          <tbody id="table-cont"></tbody>
          <tfoot>
            <tr>
              <th></th>
              <th class="th-sm">Le nom complet</th>
              <th class="th-sm">L'émail</th>
              <th class="th-sm">Statut de la demande</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="card my-3" id="dbLesArticleMisEnVente">
      <div class="card-header blue-gradient text-light text-center">
        <h4>les articles mis en vente</h4>
      </div>
      <div class="card-body overflow-auto">
        <table
          id="dt4"
          class="table table-striped table-bordered"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr>
              <th></th>
              <th class="th-sm">Le vendeur</th>
              <th class="th-sm">Email</th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date de pub</th>
              <th class="th-sm">modificatidsdonq</th>
            </tr>
          </thead>
          <tbody id="table-cont">
            <tr v-for="product in products" :key="product.ProdId">
              <th></th>
              <th>{{ product.uidSeller }}</th>
              <th>
                {{ "sc" }}
              </th>
              <th>{{ product.titreProd }}</th>
              <th>{{ product.datePub }}</th>
              <th>
                <div class="btn-group" role="group" aria-label="">
                  <button
                    type="button"
                    id="sponsor"
                    class="mx-1 btn btn-indigo btn-sm "
                    data-sponsor="' + e.val().ProdId + '"
                  >
                    Sponsoriser</button
                  ><button
                    type="button"
                    id="supPro"
                    class="mx-1 btn btn-danger btn-sm"
                    data-toggle="modal"
                    data-target="#basicExampleModal1"
                    data-supPro="' + e.val().ProdId +'"
                  >
                    supprimer
                  </button>
                </div>
              </th>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th></th>
              <th class="th-sm">Le vendeur</th>
              <th class="th-sm">Email</th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date de pub</th>
              <th class="th-sm">modification</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header blue-gradient text-light text-center">
        <h4>mes produits a vendre</h4>
      </div>
      <div class="card-body overflow-auto">
        <table
          id="dt5"
          class="table table-striped table-bordered"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr>
              <th></th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date de pub</th>
              <th class="th-sm">modification</th>
            </tr>
          </thead>
          <tbody id="table-cont"></tbody>
          <tfoot>
            <tr>
              <th></th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date de pub</th>
              <th class="th-sm">modification</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="card mb-3" id="prodSpon">
      <div class="card-header blue-gradient text-light text-center">
        <h4>les produit sponsorisés</h4>
      </div>
      <div class="card-body overflow-auto">
        <table
          id="dt7"
          class="table table-striped table-bordered"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr>
              <th></th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date de pub</th>
              <th class="th-sm">la date du sponsorisé</th>
              <th class="th-sm">le propriétaire</th>
            </tr>
          </thead>
          <tbody id="table-cont"></tbody>
          <tfoot>
            <tr>
              <th></th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date de pub</th>
              <th class="th-sm">la date du sponsorisé</th>
              <th class="th-sm">le propriétaire</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <!-- promouvoir -->
    <div class="card mb-3" id="promoPub">
      <div class="card-header blue-gradient text-light text-center">
        <h4>promouvoir un produit</h4>
      </div>
      <div class="card-body overflow-auto">
        <table
          id="dt8"
          class="table table-striped table-bordered"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr>
              <th></th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date début sponsor</th>
              <th class="th-sm">la date fin sponsor</th>
              <th class="th-sm">le propriétaire</th>
              <th class="th-sm">modification</th>
            </tr>
          </thead>
          <tbody id="table-cont"></tbody>
          <tfoot>
            <tr>
              <th></th>
              <th class="th-sm">le produit a vendre</th>
              <th class="th-sm">la date début sponsor</th>
              <th class="th-sm">la date fin sponsor</th>
              <th class="th-sm">le propriétaire</th>
              <th class="th-sm">modification</th>
            </tr>
          </tfoot>
        </table>
        <button
          class="btn btn-primary btn-rounded btn-block"
          data-toggle="modal"
          data-target="#modalLoginAvatar5"
        >
          promouvoir
          <i class="fa fa-shopping-cart text-white ml-2" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>



<script>
import { db } from "@/firebase";
import { auth } from "@/firebase";

export default {
  data() {
    return {
      products_ready: [
        {
          seller: "",
          email: "",
          product_name: "",
          date_pub: ""
        }
      ],
      products: null,
      admins: [],
      users: []
    };
  },
  firebase: {
    products: db.ref().child("products"),
    users: db.ref().child("users")
  },
  updated() {
    console.log(auth.currentUser);
    console.log(this.products, this.users);
  }
};
</script>